import { createRouter, createWebHistory } from 'vue-router'
import { TOKEN_KEY } from '@/core/storage'
import { useAuthStore } from '@/core/store/auth'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login'),
    meta: { public: true }
  },
  {
    path: '/',
    component: () => import('@/pages/layout'),
    children: [
      {
        path: '',
        redirect: '/photos'
      },
      {
        path: 'photos',
        name: 'Photos',
        meta: { title: '照片' },
        component: () => import('@/pages/photos')
      },
      {
        path: 'photos/upload',
        name: 'PhotoUpload',
        meta: { title: '上传照片' },
        component: () => import('@/pages/photos/upload')
      },
      {
        path: 'photos/:id',
        name: 'PhotoDetail',
        meta: { title: '照片详情' },
        component: () => import('@/pages/photos/detail')
      },
      {
        path: 'photos/:id/edit',
        name: 'PhotoEdit',
        meta: { title: '编辑照片' },
        component: () => import('@/pages/photos/edit')
      },
      {
        path: 'videos',
        name: 'Videos',
        meta: { title: '视频' },
        component: () => import('@/pages/videos')
      },
      {
        path: 'videos/upload',
        name: 'VideosUpload',
        meta: { title: '上传视频' },
        component: () => import('@/pages/videos/upload')
      },
      {
        path: 'videos/:id',
        name: 'VideoDetail',
        meta: { title: '视频详情' },
        component: () => import('@/pages/videos/detail')
      },
      {
        path: 'videos/:id/edit',
        name: 'VideoEdit',
        meta: { title: '编辑视频' },
        component: () => import('@/pages/videos/edit')
      },
      {
        path: 'recycle',
        name: 'Recycle',
        meta: { title: '回收站' },
        component: () => import('@/pages/recycle')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach(async (to) => {
  const auth = useAuthStore()
  const token = localStorage.getItem(TOKEN_KEY)

  if (to.meta.public) {
    if (token) {
      if (!auth.loaded || !auth.user) {
        await auth.fetchMe()
      }
      if (auth.isAuthenticated) {
        return { path: '/photos' }
      }
    }
    return true
  }

  if (!token) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }

  if (!auth.loaded || !auth.user) {
    await auth.fetchMe()
  }

  if (!auth.isAuthenticated) {
    return { name: 'Login', query: { redirect: to.fullPath } }
  }

  return true
})

export default router
